import { Country } from '@commenda/prisma';
import { TComplianceItem } from '@commenda/types/src/compliance-calendar/compliances/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

// You can either pass corporationId or the companyId. You can't pass both at the same time
export function useGetAllComplianceItems(
  token: string | undefined,
  config: {
    companyId?: number;
    corporationId?: number;
    filter?: { jurisdiction: string; country: Country };
    includeCAFirm?: boolean;
    includeAssignees?: boolean;
    includeHiddenComplianceTypes?: boolean;
    enabled?: boolean;
  }
) {
  const {
    companyId,
    corporationId,
    filter,
    includeCAFirm,
    includeAssignees,
    includeHiddenComplianceTypes,
    enabled = true,
  } = config;

  let url = 'compliance';

  const queryParams = new URLSearchParams();

  if (companyId) {
    queryParams.append('companyId', companyId.toString());
  } else if (corporationId) {
    queryParams.append('corporationId', corporationId.toString());
  }

  if (filter) {
    if (filter.jurisdiction)
      queryParams.append('jurisdiction', filter.jurisdiction.toString());

    if (filter.country)
      queryParams.append('country', filter.country.toString());
  }

  if (includeCAFirm) queryParams.append('includeCAFirm', 'true');

  if (includeAssignees) queryParams.append('includeAssignees', 'true');

  if (includeHiddenComplianceTypes)
    queryParams.append('includeHiddenComplianceTypes', 'true');

  if (queryParams.toString() !== '') {
    url += `?${queryParams.toString()}`;
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: {
      compliances: TComplianceItem[];
    };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    enabled ? url : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
